import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiOpenmindService } from '../apiopenmind.service';
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-remember',
  templateUrl: './remember-password.component.html',
  styleUrls: ['./remember-password.component.css']
})
export class RememberPasswordComponent implements OnInit {

  user = {
    email: '',
    password: '',
    errorMessage: '',
    validation:''
  }
  showError: boolean;
  Step2RememberPassword: boolean;
  Step1RememberPassword: boolean;
  Step1ChangePassword: boolean;
  Step2ChangePassword: boolean;
  showLoading: boolean;
  constructor(private router: Router, private apiopenmindservice: ApiOpenmindService, private route: ActivatedRoute) { }
  order: string;


  ngOnInit() {
    this.Step1RememberPassword = true;
    this.showError = false;
    this.Step2RememberPassword = false;
    this.Step1ChangePassword = false;
    this.Step2ChangePassword = false;
    this.showLoading = false;
    const allParams = this.router.url.toString();

    this.route.queryParams
      .subscribe(params => {
        if (params.code != null) {
          this.Step1RememberPassword = false   
          this.Step1ChangePassword = true;      
        }
      });
  } 

  cancelRequest() {
    this.router.navigate(['/']);
  }

  rememberPasswordUser() {
    this.showError = false;
    this.showLoading = true;
    this.apiopenmindservice.RememberPassword(this.user).subscribe(event => {
      this.showError = false, this.Step2RememberPassword = true, this.Step1RememberPassword = false, this.showLoading = false
    }, error => {
        this.user.errorMessage = 'Usuario no encontrado por favor verifique e intente nuevamente';
        this.showError = true;
        this.showLoading = false;
    });
   }

  ChangePassword() {
    this.showError = false;
    this.route.queryParams
      .subscribe(params => {
        if (params.code != null) {
          this.user.validation = params.code.toString();
          this.apiopenmindservice.ChangePassword(this.user).subscribe(event => {
            this.showError = false, this.Step1ChangePassword = false, this.Step2ChangePassword = true
          }, error => {
            this.user.errorMessage = 'Error cambiando contraseña por favor intente nuevamente';
            this.showError = true;
          });
        }
      });

  }

}
